import { cn } from '@/lib/utils';
import { formatVoiceGender, getVoiceLanguageFlag } from '@/lib/voice';

import type { Voice } from '@/types/agent.type';

type VoiceOptionContentProps = {
  voice: Voice;
  className?: string;
};

export function VoiceOptionContent({ voice, className }: VoiceOptionContentProps) {
  return (
    <div className={cn('flex min-w-0 items-center gap-2 text-left', className)}>
      <span aria-hidden="true" className="shrink-0 text-base leading-none">
        {getVoiceLanguageFlag(voice.language)}
      </span>

      <div className="flex min-w-0 flex-1 items-center gap-2">
        <div className="truncate text-sm font-medium text-foreground">{voice.voice_name}</div>
        <div className="flex min-w-0 items-center gap-1 whitespace-nowrap text-xs text-muted-foreground">
          <span className="shrink-0">{formatVoiceGender(voice.gender)}</span>
          <span className="text-muted-foreground/40">•</span>
          <span className="truncate">{voice.language}</span>
        </div>
      </div>
    </div>
  );
}
